import "./style.css";

export default function ClearConversationModal({
  conversation,
  currentUser,
  onClear,
  onClose,
  isVisible
}) {
  const getConversationName = () => {
    if (conversation.type === 'group') {
      return conversation.name || 'Group Chat';
    }

    const otherUser = conversation.participants.find(p => p._id !== currentUser?.id);
    return otherUser ? `${otherUser.first_name} ${otherUser.last_name}` : 'Unknown User';
  };

  if (!isVisible) return null;

  return (
    <div className="clear_conversation_modal_overlay" onClick={onClose}>
      <div className="clear_conversation_modal" onClick={(e) => e.stopPropagation()}>
        <div className="clear_conversation_header">
          <h3>Clear Conversation</h3>
          <button className="close_btn" onClick={onClose}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
              <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
            </svg>
          </button>
        </div>

        <div className="clear_conversation_content">
          <div className="clear_warning_icon">⚠️</div>
          <h4>Clear all messages?</h4>
          <p className="clear_description">
             You're about to clear your conversation with <strong>{getConversationName()}</strong>. 
             This will delete all messages from your chat history.
          </p>
          <p className="clear_note">
            <strong>Note:</strong> Once cleared, messages cannot be recovered.
          </p>
        </div>

        <div className="clear_conversation_actions">
          <button className="cancel_btn" onClick={onClose}>
            Cancel
          </button>
          <button className="clear_btn" onClick={onClear}>
            Clear Conversation
          </button>
        </div>
      </div>
    </div>
  );
} 